import React, { useState } from "react";
import InputGroup from "react-bootstrap/InputGroup";
import { Form } from "react-bootstrap";
import { FormControl } from "..";

const FormControlYearBox = ({ field, form, precision, ...rest }) => {
  const [focusClass, setFocusClass] = useState("");
  const disabled = rest.disabled;
  const onDollarInputFocus = () => {
    setFocusClass("focus");
  };

  const onDollarInputBlur = (e) => {
    const { handleBlur } = rest;
    if (e.target.value)
      e.target.value = precision
        ? parseFloat(e.target.value)?.toFixed(precision)
        : parseFloat(e.target.value)?.toFixed(2);
    setFocusClass("");
    handleBlur(e);
  };

  return (
    <FormControl {...field} {...form} {...rest} size="sm">
      <InputGroup
        className={`input-dollar-wrapper ${focusClass}`}
        style={{ maxWidth: "110px", flexWrap: "nowrap" }}
      >
        <Form.Control
          {...field}
          {...rest}
          style={{
            borderRight: "0px",
            borderRadius: "5px 0px 0px 5px",
            borderRight: "0px",
            flexGrow: 0.2,
          }}
          onFocus={onDollarInputFocus}
          onBlur={onDollarInputBlur}
        />
        <InputGroup.Prepend>
          <InputGroup.Text
            className={`input-dollar-box ${disabled ? "disabled" : ""}`}
            style={{ borderLeft: "0px", borderRadius: "0px 5px 5px 0px" }}
          >
            Years
          </InputGroup.Text>
        </InputGroup.Prepend>
      </InputGroup>
    </FormControl>
  );
};

export default FormControlYearBox;
